export default function moderationMails(templates) {
  return {
    templates: templates,
    selectedTemplate: null,
    recipients: [],
    availableRecipients: [],
    visibleRecipients: [],
    focusableElements: [],
    query: '',

    init() {
      this.focusableElements.push(this.$refs.emailInput);
      const checkboxes = this.$root.querySelectorAll('[data-recipient-email]');
      checkboxes.forEach((checkbox) => {
        const recipient = checkbox.dataset.recipientEmail;
        this.availableRecipients.push(recipient);
        this.focusableElements.push(checkbox);
      });
      this.visibleRecipients = [...this.availableRecipients];
      window.addEventListener('add-new-recipients', (evt) =>
        this.addNewRecipients(evt.detail.recipients, evt.detail.override)
      );
    },

    handleTemplateSelectionChange(templateId) {
      this.selectedTemplate = this.templates.find((template) => template.id === templateId);

      this.setEditorContent();
      this.setRecipients();
      this.setSubject();
    },

    setEditorContent() {
      const content = this.selectedTemplate.body || '';
      this.$refs.editor && tinymce.get(this.$refs.editor.id).setContent(content);
    },

    setRecipients() {
      const recipients = this.selectedTemplate.recipients || '';
      this.$dispatch('add-new-recipients', { recipients: recipients, override: true });
    },

    setSubject() {
      const subject = this.selectedTemplate.subject || '';
      this.$refs.subject.value = subject;
    },

    toggleRecipient(recipient) {
      const recipientMail = recipient.value;
      this.recipients = recipient.checked
        ? [...this.recipients.filter((mail) => mail !== recipientMail), recipientMail]
        : this.recipients.filter((mail) => mail !== recipientMail);
    },

    filterRecipients() {
      this.visibleRecipients = this.availableRecipients.filter((mail) =>
        mail.toLowerCase().includes(this.query.toLowerCase())
      );
    },

    addNewRecipients(recipients = '', override = false) {
      let newRecipients = recipients ? recipients.split(',') : this.query.split(',');
      newRecipients = newRecipients.map((recipient) => recipient.trim()).filter((recipient) => recipient);
      if (newRecipients.length === 0 && override) this.clearRecipients();
      if (newRecipients.length === 0) return;

      newRecipients.forEach((newRecipient) => {
        const mail = newRecipient.trim();
        if (!mail || this.recipients.includes(mail)) return;
        this.recipients.push(mail);
      });
      this.clearNewRecipients();
    },

    clearNewRecipients() {
      this.query = '';
      this.visibleRecipients = this.availableRecipients;
      this.$refs.emailInput?.focus();
    },

    clearRecipients() {
      this.recipients = [];
      this.$root.focus();
    },

    focusNext() {
      const focusIndex = this.focusableElements.findIndex((el) => el === document.activeElement);
      const nextIndex = focusIndex + 1 >= this.focusableElements.length ? 0 : focusIndex + 1;
      this.focusableElements[nextIndex].focus();
    },

    focusPrevious() {
      const focusIndex = this.focusableElements.findIndex((el) => el === document.activeElement);
      const previousIndex = focusIndex - 1 < 0 ? this.focusableElements.length - 1 : focusIndex - 1;
      this.focusableElements[previousIndex].focus();
    },
  };
}
